import axios from '@/libs/api.request'

export const getComponentPriceHistories = (mpn, brand) => {
  return axios.request({
    url: `search/component_price_history?mpn=${mpn}&brand=${brand}`,
    method: 'get'
  })
}

export const getMultiComponentsMostRecentPrice = (payload) => {
  return axios.request({
    url: `search/component_price_histories`,
    method: 'post'
  })
}

export const callExtractComponentsPricesJob = (payload) => {
  return axios.request({
    url: '/costs/jobs/extract-components-prices',
    method: 'POST',
    data: payload
  })
}

export const uploadComponentPrice = (file, pricing_date) => {
  let formdata = new FormData()
  formdata.append('file', file)
  if (pricing_date) {
    formdata.append('pricing_date', pricing_date)
  }
  return axios.request({
    url: 'etl/component-price/import',
    method: 'post',
    data: formdata,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then((res) => { return res.data })
}
